"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var baseSpacing = 24;
var theme = {
  global: {
    colors: {
      disabledColor: '#bdc3c7',
      primaryColor: '#FFC729',
      secondaryColor: '#FFC729',
      tertiaryColor: '#FFC729'
    },
    opacity: {
      strong: 0.8,
      medium: 0.4,
      weak: 0.1
    }
  },
  colors: {
    disabledColor: '#bdc3c7',
    primaryColor: '#FFC729',
    secondaryColor: '#FFC729',
    tertiaryColor: '#FFC729'
  },
  breakpoints: {
    small: {
      value: baseSpacing * 32,
      // 768
      borderSize: {
        xsmall: '1px',
        small: '2px',
        medium: "".concat(baseSpacing / 6, "px"),
        // 4
        large: "".concat(baseSpacing / 4, "px"),
        // 6
        xlarge: "".concat(baseSpacing / 2, "px") // 12

      },
      edgeSize: {
        none: '0px',
        hair: '1px',
        // for Chart
        xxsmall: '2px',
        xsmall: "".concat(baseSpacing / 8, "px"),
        // 3
        small: "".concat(baseSpacing / 4, "px"),
        // 6
        medium: "".concat(baseSpacing / 2, "px"),
        // 12
        large: "".concat(baseSpacing, "px"),
        // 24
        xlarge: "".concat(baseSpacing * 2, "px") // 48

      },
      size: {
        xxsmall: "".concat(baseSpacing, "px"),
        // 24
        xsmall: "".concat(baseSpacing * 2, "px"),
        // 48
        small: "".concat(baseSpacing * 4, "px"),
        // 96
        medium: "".concat(baseSpacing * 8, "px"),
        // 192
        large: "".concat(baseSpacing * 16, "px"),
        // 384
        xlarge: "".concat(baseSpacing * 32, "px"),
        // 768
        full: '100%'
      }
    },
    medium: {
      value: baseSpacing * 64 // 1536

    },
    large: {} // anything above 'medium'

  }
};
var _default = theme;
exports["default"] = _default;